<template>
  <div v-if="visible" class="mask" @click.self="$emit('close')">
    <div class="modal modal-xl recharge-modal">
      <button type="button" class="modal-close" @click="$emit('close')">×</button>
      <h3>积分充值</h3>
      <div v-if="loading" class="plan-state">加载套餐中…</div>
      <div v-else-if="!plans || !plans.length" class="plan-state muted">暂无可用套餐，请稍后重试</div>
      <div v-else class="plan-grid">
        <div v-for="(item, idx) in plans" :key="planKey(item, idx)" class="plan-card">
          <div v-if="item.title" class="plan-title">{{ item.title }}</div>
          <div class="points">{{ item.points }} 积分</div>
          <div class="price">¥{{ formatPrice(item.price) }}</div>
          <button type="button" class="main-btn" @click="openPayPicker(item)">立即购买</button>
        </div>
      </div>
    </div>

    <pay-method-picker
      :visible="payPickerVisible"
      :subtitle="payPickerSubtitle"
      @close="closePayPicker"
      @confirm="onPayConfirm"
    />
  </div>
</template>

<script>
import PayMethodPicker from "./PayMethodPicker.vue";

export default {
  name: "RechargeModal",
  components: { PayMethodPicker },
  props: {
    visible: { type: Boolean, default: false },
    plans: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      payPickerVisible: false,
      selectedPlan: null
    };
  },
  computed: {
    payPickerSubtitle() {
      if (!this.selectedPlan) return "";
      return `${this.selectedPlan.points} 积分 / ¥${this.formatPrice(this.selectedPlan.price)}`;
    }
  },
  methods: {
    openPayPicker(item) {
      this.selectedPlan = item || null;
      this.payPickerVisible = true;
    },
    closePayPicker() {
      this.payPickerVisible = false;
      this.selectedPlan = null;
    },
    onPayConfirm({ payType }) {
      if (!this.selectedPlan) return;
      this.$emit("buy", { ...this.selectedPlan, payType });
      this.closePayPicker();
    },
    planKey(item, idx) {
      if (item && item.id != null && item.id !== "") return String(item.id);
      return `p-${item && item.points != null ? item.points : idx}-${idx}`;
    },
    formatPrice(v) {
      const n = Number(v);
      if (Number.isNaN(n)) return "—";
      if (Number.isInteger(n)) return String(n);
      return n.toFixed(2);
    }
  }
};
</script>

<style scoped>
/* 限高 + plan-grid 内滚动：纵向居中时关闭按钮仍在视口内 */
.recharge-modal {
  position: relative;
  width: min(620px, calc(100vw - 20px));
  max-width: 100%;
  max-height: min(88vh, calc(100vh - 28px));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.recharge-modal .modal-close {
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 10;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 8px;
  background: rgba(40, 40, 40, 0.95);
  color: #fff;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.12);
}

.recharge-modal h3 {
  flex-shrink: 0;
  margin: 0 0 10px;
  padding: 6px 44px 0 4px;
  font-size: 18px;
  line-height: 1.3;
}

.plan-state {
  margin-top: 0;
  padding: 16px 8px;
  text-align: center;
  font-size: 14px;
  color: #e0e0e0;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.plan-state.muted {
  color: #888;
}

.recharge-modal .plan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(195px, 1fr));
  gap: 10px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  align-content: start;
}

.plan-title {
  font-size: 13px;
  color: #bdbdbd;
  margin-bottom: 6px;
}

.recharge-modal .plan-card {
  padding: 8px;
}

.recharge-modal .points {
  font-size: 15px;
  margin: 4px 0;
}

.recharge-modal .price {
  font-size: 16px;
  margin: 6px 0 8px;
}

.recharge-modal .main-btn {
  height: 32px;
  font-size: 13px;
}

.pay-type-row {
  margin: 10px 0;
  display: flex;
  gap: 12px;
  justify-content: center;
  font-size: 12px;
}

@media (max-width: 380px) {
  .recharge-modal .plan-grid {
    grid-template-columns: 1fr;
  }
}
</style>
